import * as $ from 'jquery';
import {bootCheckoutFormHandler} from "@/js/handlers/CheckoutFormHandler";
import {handleRating, SendCommentHandler} from "@/js/handlers/LoadCommentsHandler";
import {bootCartFormHandler} from "@/js/handlers/CartFormHandler";
import {bootAddToCard, bootRemoveFromCart} from "@/js/shop/Card";
import {MobileFilterTrigger} from "@/js/shop/MobileFilterTrigger";
import {SetVisitedProducts} from "@/js/shop/SetVisitedProducts";
import {ZoomImage} from "@/js/shop/ZoomImage";


MobileFilterTrigger();
bootCheckoutFormHandler();
bootCartFormHandler();
bootAddToCard();
bootRemoveFromCart();
handleRating();
SendCommentHandler();
SetVisitedProducts();
ZoomImage();
